import { message } from 'antd';

/**
 * Reusable event change manager.
 */
export const createHandleEventChange = ({
                                            form,
                                            events,
                                            setSelectedEventId,
                                            setProgrammePoints,
                                            setLocations,
                                            setParticipantTypes,
                                            setCustomFields,
                                            setShowEFN,
                                            fetchToken,
                                            fetchEventDetails
                                        }) => {
    return async (eventId) => {
        setSelectedEventId(eventId);

        // Reset event dependencies
        form.setFieldsValue({
            SelectedEventId: eventId ?? null,
            SelectedProgrammePointId: null,
            SelectedProgrammePointName: null,
            SelectedLocationId: null,
            CustomSeatFieldIds: [],
            IsEFNCheckEnabled: false,
            TextEFNError: undefined,
        });

        setProgrammePoints([]);
        setLocations([]);
        setParticipantTypes([]);
        setCustomFields([]);

        if (!eventId) {
            setShowEFN(false);
            return;
        }

        const selectedEvent = events.find(ev => ev._id === eventId);
        if (!selectedEvent || !selectedEvent.eventId || !selectedEvent.host_url) {
            message.warning('Event not valid. Please select another one.');
            setShowEFN(false);
            return;
        }

        setShowEFN(selectedEvent.countryPK === 'DE');

        const token = await fetchToken(selectedEvent.host_url);
        if (token) {
            await fetchEventDetails(selectedEvent.eventId, token, selectedEvent.host_url);
        }
    };
};